import React from 'react';
import { Textarea, Label, ErrorText } from '../lib';

const TextArea = React.forwardRef((props, ref) => {
    const { name, label, error, ...rest } = props;

    return (
        <div style={{ marginBottom: '10px', width: '100%', marginTop: '20px' }}>
            <Label htmlFor={name}>{label}</Label>
            <Textarea name={name} ref={ref} style={{resize:'none'}} {...rest} />
            {error && <ErrorText>{error}</ErrorText>}
        </div>
    )
});

export default TextArea;